import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";

import useScrollPosition from "use-scroll-position";
import useDocDimensions from "./hooks/useDocDimensions";

import PageContainer from "./components/pages/PageContainer";
import pages from "./components/pages/pages";

import MoodboardPage from "./components/pages/MoodboardPage";
import NotFoundPage from "./components/pages/NotFoundPage";
import useData from "./hooks/useData";
//import useUser from './hooks/useUser';

function AppContents({ loaded, match }) {
  const { width, height } = useDocDimensions();

  const { moodboards, user: userState } = useData();

  const { pathname } = useLocation();

  const scrollPos = useScrollPosition();

  const [selectedPage, setSelectedPage] = useState(null);

  useEffect(() => {
    for (let i = 0; i < pages.length; i++) {
      if (pages[i].path === pathname) {
        setSelectedPage(i);
      }
    }
  }, [pathname]);

  return (
    <PageContainer width={width} minHeight={height}>
      <Switch>
        {pages.map((page, index) => (
          <Route
            key={page.path}
            path={page.path}
            exact
            render={() =>
              React.createElement(page.component, {
                selected: selectedPage === index,
                height,
                moodboards,
                user: userState,
                width,
                scroll: scrollPos,
              })
            }
          />
        ))}
        <Route
          path={"/:routeId"}
          render={() =>
            React.createElement(MoodboardPage, {
              height,
              user: userState,
              width,
              scroll: scrollPos,
            })
          }
        />
        <Route
          render={() =>
            React.createElement(NotFoundPage, {
              height,
              width,
            })
          }
        />
      </Switch>
    </PageContainer>
  );
}

function App() {
  return (
    <Router>
      <AppContents />
    </Router>
  );
}

export default App;
